<pds-module-header title="Compras" ctaLabel="Voltar" ctabuttonType="primary" ctaPath="..">
  <pds-new-breadcrumb [items]="breadcrumb" />
  <pds-panel>
    <pds-form [formGroup]="form" (ngSubmit)="onSubmit()">
      <pds-form-row grid="1-1-1">
        <pds-form-field label="ID do pedido">
          <input type="text" formControlName="commerceReference" placeholder="PA-00001" />
        </pds-form-field>
        <pds-form-field label="Vendedor">
          <pds-autocomplete placeholder="Razão social, nome fantasia ou nome comercial" formControlName="branch" [source]="branches$" (autocomplete)="onAutocompleteBranches($event)" />
        </pds-form-field>
        <pds-form-field label="Status">
          <pds-select formControlName="status" [options]="status" />
        </pds-form-field>
      </pds-form-row>
      <pds-form-actions>
        <button pdsButton="primary" (click)="clearFilters()" type="button" [disabled]="form.pristine">Limpar filtros</button>
        <button pdsButton type="submit">Buscar</button>
      </pds-form-actions>
    </pds-form>
    <hr />
    <ng-container *ngIf="orders$ | async; let orders">
      <ng-container *ngIf="orders.data && orders.data.length">
        <pds-table>
          <table>
            <thead>
              <tr>
                <th>Vendedor</th>
                <th>ID</th>
                <th>Status</th>
                <th>Data / Hora</th>
                <th>Valor</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let order of orders.data">
                <td>
                  <div class="purchase-list-item__company-name">
                    <strong>{{ order.branch.companyName }}</strong>
                    <small>{{ order.branch.commercialName }} ({{ order.branch.externalReference }})</small>
                  </div>
                </td>
                <td>{{ order.order?.commerceReference }}</td>
                <td>
                  <span [pdsChip]="order.status | statusColor">{{ order.status | status }}</span>
                </td>
                <td>{{ order.audit?.createdAt | date : 'dd/MM/yy HH:mm' }}</td>
                <td>{{ order.amount | currency : 'BRL' }}</td>
                <td pdsColActions>
                  <button *ngIf="hasNFe(order)" pdsButton="icon" title="Baixar NFe" (click)="onClickDownloadNFe(order)">
                    <span class="icon">picture_as_pdf</span>
                  </button>
                  <button pdsButton="icon" title="Ver Detalhes" (click)="onClickDetails(order)">
                    <span class="icon">visibility</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </pds-table>
      </ng-container>
      <ng-container *ngIf="orders.data && !orders.data.length">
        <strong>Nenhuma ordem de compra encontrada.</strong>
      </ng-container>
      <ng-container *ngIf="orders.failure">
        <strong>Falha ao carregar ordens de compra.</strong>
      </ng-container>
      <ng-container *ngIf="orders.loading">
        <strong>carregando...</strong>
      </ng-container>

      <pds-pagination [pagination]="pagination$" (paginate)="onPaginate($event)" />
    </ng-container>
  </pds-panel>
</pds-module-header>
